export default __webpack_public_path__ + "static/media/FiraSans-Medium.1deec596.woff2";